import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { PostFactoryComponent } from './post-factory.component';
import { InputModule } from '../input';
import { FormFieldModule } from '../form-field';
import { ButtonModule } from '../button';

@NgModule({
  declarations: [PostFactoryComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    FormFieldModule,
    ButtonModule,
  ],
  exports: [PostFactoryComponent],
})
export class PostFactoryModule {}
